<template>

<v-dialog v-model="show"
          max-width="1200px">

  <template v-slot:activator="{ on }">
    <v-btn color="success" v-on="on">
      <v-icon left>mdi-help-circle-outline</v-icon>
      Help
    </v-btn>
  </template>

  <v-card>
    <v-card-title class="headline grey lighten-2"
                  primary-title>
      Привет!
    </v-card-title>

    <v-card-text class="black--text body-1">

      <br/>

      <p>
        Это <strong>прототип</strong> софта для исследования пространства решений сложных проблем.
      </p>

      <p>
        Он может пригодиться, если вам необходимо найти решение / выбрать архитектуру / определить лучшее сочетание параметров в сложной и / или слабо формализированной области.
      </p>

      <p>
        Например, вы знаете, что решение может обладать свойствами A, B, C, D, … Z, но не знаете какое сочетание свойств будет оптимальным. При том, что A и D несовместимы, а сочетание свойств B+X+Y выглядит лучше, чем P+Q.
      </p>

      <p>
        В этом случае вы можете ввести список свойств, ограничения, и поэкспериментировать, меняя правила подбора и оценки решений.
      </p>

      <p>
        По сути, софт помогает делать полный перебор всех вариантов решений с ограничениями.
      </p>

      <p>
        Немного подробнее написано в википедии: <a href="https://ru.wikipedia.org/wiki/Морфологический_анализ_(изобретательство)">морфологический анализ</a>.
      </p>

      <p>
        Для обсуждения есть чат в <a href="https://t.me/joinchat/HA7ACB09k1-CXOuSSog4Vg">Телегам</a>.
      </p>

      <p>
        <strong>Я буду очень благодарен за любые отзывы, критику, предложения, etc…</strong>
      </p>

      <h2>Моя мотивация</h2>

      <br/>

      <p>
        Несколько раз в месяц мне приходится решать нестандартные задачи. Обычно они предполагают нетривиальный выбор из нескольких альтернативных решений, иногда оказывается, что интересное решение я упустил из рассмотрения. Поэтому я давно ищу инструмент, который упростил бы «исследовательскую» часть работы.
      </p>

      <p>
        Предполагаю, что я не один такой.
      </p>

      <p>
        В попытках найти такой инструмент я залез довольно глубоко в интернеты иии… ничего не нашёл. То есть нашёл: дорогой корпоративный софт, который мне и посмотреть не дадут, скудненькие научные статьи на эту тему (в том числе, с примерами решения правительственных задач этим методом) и один недопрототип на гитхабе.
      </p>

      <p>
        В итоге звёзды сошлись так, что у меня появилось и время и мотивация.
      </p>

      <p>
        Я уверен, что сама проблема существует и что софта для её решения нет. Но не уверен, что выбранный мной подход оптимален.
      </p>

      <p>
        Этим прототипом я хочу проверить выбранное направление движения, собрать ваши отзывы и советы.
      </p>

      <h2>Вопросы</h2>

      <br/>

      <p>
        Вот некоторые вопросы, за любое ваше мнение по которым я буду благодарен.
      </p>

      <ol>
        <li>Актуальна ли проблема?</li>
        <li>Может быть можно уточнить / переформулировать проблему? Расширить или сузить.</li>
        <li>Правильно ли выбрано направление развитие софта?</li>
        <li>Какую терминологию лучше использовать? Английскую и русскую. С терминами пока «беда».</li>
        <li>На какой ЦА лучше сосредоточиться в первую очередь? Может есть какие-нибудь малоизвестные сообщества?</li>
        <li>Какие задачи взять для примеров?</li>
        <li>Где / кому / в каких сообществах лучше это показывать?</li>
        <li>Что работает, что не работает, чего не хватает?</li>
        <li>Пытаться это направление развивать как коммерческое? Как open source? Забить?</li>
      </ol>

      <br/>

      <h2>Как пользоваться</h2>

      <br/>

      <p>
        <strong>Слева</strong> вы можете увидеть блок <var>Solution Info</var> — это панель с главной информацией о текущем решении (если оно найдено).
      </p>

      <p>
        Если вы нажмёте кнопку <v-btn color="success" small>SOLVE</v-btn>, то софт попробует найти решение по текущим данным.
      </p>

      <p>
        <strong>Сверху справа</strong> находится несколько общих команд, среди них:
      </p>

      <ul>
        <li><v-btn color="success" small><v-icon left>mdi-help-circle-outline</v-icon>Help</v-btn> показывает этот диалог;</li>
        <li><v-btn color="warning" small>Examples<v-icon right>mdi-chevron-down</v-icon></v-btn> позволяет загрузить один из подготовленных примеров.</li>
      </ul>

      <br/>

      <p>
        <strong>Сверху слева</strong> панель переключения между режимами работы / отображения информации:
      </p>

      <ul>
        <li><var>Groups</var> — основной режим, позволяет создавать свойства, группы свойств и настраивать самые простые ограничения</li>
        <li><var>Rules</var> — режим отображения правил — ограничений перебора — позволяет задавать сложные правила и просто отображает все ограничения «как есть».</li>
        <li><var>Solutions</var> — список найденных решений.</li>
        <li><var>Advices</var> — список советов, как улучшить решение. Советы — результат работы эвристик, после нахождения хоть какого-нибудь решения (на текущий момент).</li>
      </ul>

      <h3>Groups</h3>

      <p>
        Основная вкладка. Позволяет просматривать и редактировать группы свойств. В том числе позволяет задавать самые простые ограничения.
      </p>

      <p>
        Пояснение по описанию группы:
      </p>

      <div class="d-flex">
        <img align="left" src="../../images/group_gui.png"/>

        <ol style="list-style-position: inside;">
          <li>Аватарка группы, используется в других вкладках при отображении входящих в неё свойств.</li>
          <li>Сколько свойств из группы может быть в решении (от x до y включительно).</li>
          <li>Это свойство обязательно должно быть включено в решение.</li>
          <li>Это свойство обязательно должен быть исключено из решения.</li>
          <li>Кнопка выбора режима свойства (опционально, обязательно, запрещено).</li>
        </ol>
      </div>

      <h3>Rules</h3>

      <p>
        Список всех правил / ограничений. Обратите внимание, группы — те же ограничения, поэтому присутствуют на этой вкладке, но в другом виде.
      </p>

      <p>
        Часть правил имеет серый заголовок с замочком — это «системные» правила, управляемые через другие части интерфейса (в данный момент, во вкладке Groups).
      </p>

      <p>
        Все правила действуют по одному принципу: находят пересечение множества своих свойств со свойствами проверяемого решения и на основе результата делают соответствующие действия.
      </p>

      <p>
        Каждое правило состоит из трёх частей:
      </p>

      <ul>
        <li>Действие при срабатывании:
          <ul>
            <li><var>Reject Solution</var> — отклонить проверяемое решение, если сработает условие.</li>
            <li><var>Accept Solution</var> — отклонить проверяемое решение, если не сработает условие.</li>
            <li><var>Change Solution Score at</var> — изменить оценку проверяемого решения, если сработает условие.</li>
          </ul>
        </li>

        <li>Условия срабатывания:
          <ul>
            <li><var>solution contains all of items</var> — решение содержит все свойства из шаблона.</li>
            <li><var>solution contains none of items</var> — решение не содержит ни одно свойство из шаблона.</li>
            <li><var>solution contains N of items</var> — решение содержит от x до y свойств из шаблона.</li>
          </ul>
        </li>

        <li>Шаблон — «регулярное выражение», описывающее наборы свойств, которыми оперирует правило. </li>
      </ul>

      <p>
        Представление шаблона как выражения для генерации свойств, вместо их простого перечисления, позволяет значительно сократить количество необходимых правил и в целом удобно (смотрите пример с одеждой).
      </p>

      <p>
        Шаблон читается слева направо «по стрелочкам». Каждый вариант пути по стрелочкам соответствует одному набору свойств. Чтобы правило сработало, его условие должно сработать хотя бы на одном из наборов.
      </p>

      <p>
        Пример правила с шаблоном:
      </p>

      <div class="d-flex">
        <img align="left" src="../../images/rule_template_example.png"/>

        <p class="ml-1">
          Правило отклонит проверяемое решение, если в нём попадётся любое сочетание бюжетерии из серебра из золота (шаблон описывает 4 возможных сочетания).
        </p>
      </div>

      <h3>Solutions</h3>

      <p>
        После того, как будут обработаны все варианты решений, в этой вкладке будет список лучших 100. Для каждого решения можно посмотреть пояснение по его итоговой оценке, если кликнуть по надписи «score X».
      </p>

      <h3>Advices</h3>

      <p>
        Этот режим работы, потенциально, должен быть самым интересным. Во вкладке должна происходить интерактивная работа с эвристиками, которые должны помогать сократить область поиска и уточнить оценку решений.
      </p>

      <p>
        На текущий момент реализовано несколько простых эвристик «для теста», которые просто дают советы (попробуйте пример со снегоходом).
      </p>

    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>

      <v-spacer></v-spacer>
      <v-btn color="primary"
             text
             @click="show = false">
        Всё ясно
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

</template>

<script>

export default {
    name: "MorphologyHelp",

    components: {
    },

    data: function() {
        return {show: (localStorage.getItem('showHelp') === null || localStorage.showHelp === 'true')};
    },

    props: [],

    computed: {
    },

    methods: {
    },

    watch: {
        show(newShow) {
            if (newShow) {
                this.$gtag.event('show_help', {});
            }
            else {
                this.$gtag.event('hide_help', {});
            }

            localStorage.showHelp = newShow;
        }
    }
}
</script>
